@if (!!customer();) {
<div class="app-selected-box">
  <div class="flex-row space-between-center" style="font-weight: bold">
    {{ customer()?.name }}
    <button matButton matSuffix aria-label="Clear" (click)="clearCustomer()">
      <mat-icon style="color: #2c2c2c; font-size: 1.8em; font-weight: 900"
        >close</mat-icon
      >
    </button>
  </div>
  <span>{{ customer().postal }} {{ customer()?.city }}</span>
  <span>{{ customer()?.address }}</span>
  <span style="padding-top: 0.8em"> NIP {{ customer().nip }}</span>
</div>
}
